<div class="container-fluid vh-100 bg-light d-flex justify-content-center align-items-center">
  <div class="text-center px-3" style="max-width: 500px; width: 100%;">
    <!-- Logo Section -->
    <div class="mb-4">
      <img
        [ngSrc]="imgSrc"
        alt="NAUTOPSY Logo"
        class="img-fluid mb-3"
        width="660"
        height="371"
        priority
      />
    </div>

    @if (isDemo) {
      <!-- Demo Login Form -->
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Felhasználó kiválasztása</mat-label>
            <mat-select (selectionChange)="onDemoUserSelected($event.value)">
              @for (user of demoUsers; track user.username) {
                <mat-option [value]="user">{{ user.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="d-grid">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="!selectedDemoUser() || isLoading()"
          >
            @if (isLoading()) {
              <mat-spinner diameter="20" class="me-2" style="display: inline-block;"></mat-spinner>
            }
            {{ isLoading() ? 'Bejelentkezés...' : 'Bejelentkezés' }}
          </button>
        </div>
      </form>
    } @else {
      <!-- Standard Login Form -->
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <!-- Username Field -->
        <div class="mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Felhasználónév</mat-label>
            <input
              matInput
              type="username"
              [formControl]="loginForm.controls.username"
              autocomplete="username"
            />
            @if (loginForm.controls.username.hasError('required') &&
            loginForm.controls.username.touched) {
              <mat-error class="text-danger">Felhasználónév megadása kötelező!</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Password Field -->
        <div class="mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Jelszó</mat-label>
            <input
              matInput
              [type]="hidePassword() ? 'password' : 'text'"
              [formControl]="loginForm.controls.password"
              autocomplete="current-password"
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="hidePassword.set(!hidePassword())"
              [attr.aria-label]="'Jelszó ' + (hidePassword() ? 'megjelenítés' : 'elrejtés')"
              [attr.aria-pressed]="!hidePassword()"
            >
              <mat-icon>{{ hidePassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            @if (loginForm.controls.password.hasError('required') &&
            loginForm.controls.password.touched) {
              <mat-error class="text-danger">Jelszó megadása kötelező!</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Forgot Password Link -->
        <div class="mb-3">
          <button
            type="button"
            class="btn btn-link text-info text-decoration-none"
            (click)="forgotPassword()"
          >
            Elfelejtette a jelszavát?
          </button>
        </div>

        <!-- Login Button -->
        <div class="d-grid">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="loginForm.invalid || isLoading()"
          >
            @if (isLoading()) {
              <mat-spinner diameter="20" class="me-2" style="display: inline-block;"></mat-spinner>
            }
            {{ isLoading() ? 'Bejelentkezés...' : 'Bejelentkezés' }}
          </button>
        </div>
      </form>
    }
  </div>
</div>
